













































































































import { Vue, Watch, Component } from "vue-property-decorator";
import { TestsList as ITestList } from "@/api/models/tests-list";
import TestTable from "@/components/tests/TestTable.vue";
import tests, { TestListParams } from "@/getinfo-api/tests";
import { Test as ITest } from "@/api/models/test";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import {
  getCurrentCompanyId,
  isRoot,
  getCurrentEmployee,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { SortFields, TestsSort } from "@/plugins/sort-fields";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CSingleSelect,
    CField,
    CPage,
    CustomTable,
    CustomButton,
    TestTable
  }
})
export default class TestList extends Vue {
  titleSearch!: string | undefined;
  isTestEnabled: boolean | undefined;
  testCount: number = 0;
  tests: Array<ITest> = [];
  limit: number = 30;
  offset: number = 0;
  showSpinner: boolean = false;
  showMoreSpinner: boolean = false;
  sorted: SortFields<TestsSort> = new SortFields(TestsSort.updatedAt);
  locale: string | undefined = "";

  data() {
    return {
      titleSearch: undefined,
      isTestEnabled: undefined
    };
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get sortStatus() {
    return TestsSort;
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get employee() {
    return getCurrentEmployee();
  }

  get contentManager() {
    return this.employee?.roles?.includes("content_manager");
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  @Watch("selectedCompanyId")
  updateTable() {
    this.tests = [];
    this.offset = 0;
    this.getCompanyTestList();
  }

  acceptSort(sort: TestsSort) {
    this.sorted.changeSort(sort);
    this.applyFilter();
  }

  applyFilter() {
    this.tests = [];
    this.offset = 0;
    this.testCount = 0;
    this.showSpinner = true;
    this.getCompanyTestList();
  }

  clearFilter() {
    this.isTestEnabled =
      this.root || this.companyOwner || this.contentManager ? undefined : true;
    this.titleSearch = undefined;
    this.locale = undefined;
    this.applyFilter();
  }

  getCompanyTestList(offset: number = 0) {
    this.showSpinner = true;
    let param: TestListParams = {
      companyId: this.selectedCompanyId,
      title: this.titleSearch ? this.titleSearch : undefined,
      limit: this.limit,
      offset: offset,
      sort: this.sorted.sort,
      enabled: this.isTestEnabled,
      locale: this.locale,
      order: this.sorted.order
    };
    tests(param)
      .then((res: { data: ITestList }) => {
        this.tests = [...this.tests, ...res.data.tests];
        this.testCount = res.data.count;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
        this.showMoreSpinner = false;
      });
  }

  showMore() {
    this.showMoreSpinner = true;
    this.offset += this.limit;
    this.getCompanyTestList(this.offset);
  }

  mounted() {
    this.getCompanyTestList();
  }
}
